__turbopack_context__.v({
  "disablePointerEvents": "style-module-scss-module__hzhdva__disablePointerEvents",
  "player": "style-module-scss-module__hzhdva__player",
  "thumbnail": "style-module-scss-module__hzhdva__thumbnail",
  "wrapper": "style-module-scss-module__hzhdva__wrapper",
});
